/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    code: "code"
  }, _provideComponents(), props.components);
  return _jsxs(_components.p, {
    children: ["На первый взгляд всё в порядке, но если сам интерфейс ", _jsx(_components.code, {
      children: "AreaCalculatable"
    }), " изменится, класс ", _jsx(_components.code, {
      children: "Square"
    }), " перестанет ему соответствовать, а без директивы ", _jsx(_components.code, {
      children: "implements"
    }), " компилятор не сможет об этом предупредить"]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
